exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FiscalSalesZreport{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/fiscal-sales-zreport/fiscal-sales-zreport.scss
// module id = 1356
// module chunks = 0